export class SimpleStorage {
  value: string | null = null
  key: string

  constructor(key: string) {
    this.key = key
  }

  get = () => {
    return this.value
  }

  set = (value: string | null) => {
    this.value = value
  }
}
